import React from 'react';
import './App.css';
import Dashboard from './Screens/Dashboard';
import Login from './Screens/Login';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import UploadScreen from './Screens/UploadScreen';
import 'bootstrap/dist/css/bootstrap.min.css';
import Submitted from './Screens/Submitted';
import Privacy from './Screens/Privacy';
import ROUTES from './Navigation/routes';

function App() {
  return (
    <Router>
        <Routes>
          <Route path={ROUTES.LOGIN}  element={<Login />}>
          </Route>
          <Route path={ROUTES.DASHBOARD}  element={<Dashboard />}>
          </Route>
          <Route path={ROUTES.QUESTION} element={<UploadScreen />}>
          </Route>
          <Route path={ROUTES.SUBMITTED}  element={<Submitted />}>
          </Route>
          <Route path={ROUTES.PRIVACY}  element={<Privacy/>}>
          </Route>
        </Routes>
    </Router>
  );
}

export default App;
